<ng-container *ngIf="pagingInfo.totalItems > pagingInfo.pageSize">
    <strong>Page</strong>
    <pagination
        firstText="&nbsp;"
        lastText="&nbsp;"
        previousText="&nbsp;"
        nextText="&nbsp;"
        [(ngModel)]="pagingInfo.pageIndex"
        [itemsPerPage]="pagingInfo.pageSize"
        [totalItems]="pagingInfo.totalItems"
        (numPages)="pagingInfo.pageCount"
        [maxSize]="5"
        [rotate]="false"
        [boundaryLinks]="true"
        (pageChanged)="pageChanged($event)"
    ></pagination>
</ng-container>

<div class="counter-value">
    {{ pagingInfo.pageFirstNo }} - {{ renderedCount }} of {{ pagingInfo.totalItems }}
</div>

<ui-dropdown-simple
    class="paging-dd"
    [selectedValue]="pagingInfo.pageSize"
    [optionsList]="pageSizesList"
    [showListOnTop]="showPaginationListOnTop"
    (valueChange)="onPageSizeSelect($event)"
></ui-dropdown-simple>
